import { render, staticRenderFns } from "./index copybeifen.vue?vue&type=template&id=7f5169ee&scoped=true&"
import script from "./index copybeifen.vue?vue&type=script&lang=js&"
export * from "./index copybeifen.vue?vue&type=script&lang=js&"
import style0 from "./index copybeifen.vue?vue&type=style&index=0&id=7f5169ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5169ee",
  null
  
)

export default component.exports